export default class MutationUtils {
  static makeSetStateMutation(stateField) {
    return (state, value) => {
      state[stateField] = value;
    };
  }

  static makeUpdateListStateMutation(stateField) {
    return (state, value) => {
      state[stateField] = [...state[stateField].filter((x) => x.id !== value.id), value];
    };
  }
}
